// extracted by mini-css-extract-plugin
export default {"barChart":"BarChart_barChart__Q3SL5","info":"BarChart_info__hhFen","name":"BarChart_name__ZtCAR","counter":"BarChart_counter__2BEWY"};